export default __webpack_public_path__ + "static/media/Aioi.1b430774.png";